import styled from 'styled-components';

const StoreChangeWrapper = styled.div`
  display: flex;
  text-transform: capitalize;

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    margin-left: 0px;
    font-weight: bold;
  }
`;

export const ChangeStoreLinkText = styled.div`
  font-size: 14px;
  display: inline-block;
  cursor: pointer;
  text-decoration: underline;
  margin-top: 2px;
  color: ${(props) => props.theme.colors.BUTTON.BLUE.LEFT_FILTERS_BTN};
  @media ${(props) => props.theme.mediaQuery.medium} {
    &.select-store {
      font-size: 14px;
      margin-top: 2px;
    }
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: 12px;
  }
`;

export default StoreChangeWrapper;
